import React from "react";
import AddEstacionForm from "./AddEstacionForm";

const AddEstacion = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Estacion"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddEstacionForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddEstacion;
